export class StartGitIntegrationAuthorizationResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "authorizeUrl",
            "baseName": "authorizeUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return StartGitIntegrationAuthorizationResponse.attributeTypeMap;
    }
    constructor() {
    }
}
